import { createActionWithCallback } from 'core/store/utils';

export const fetchKeywords = createActionWithCallback<string[], Error>()('fetchKeywords');

export default { fetchKeywords };
